import { ethers, BigNumber } from 'ethers';
import { getAddress } from './get-address';
import TokenExchange from '../abi/TokenExchange.json';
import ERC20 from '../abi/ERC20.json';

export const deposit = async (_address, _amount) => {
  try {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const { chainId } = await provider.getNetwork();
    const addresses = getAddress(chainId);

    if (addresses) {
      const signer = provider.getSigner();
      const tokenExchange = new ethers.Contract(
        addresses.token_exchange_address,
        TokenExchange.abi,
        signer
      );
      const formattedNum = parseInt(_amount);
      const tokenContract = new ethers.Contract(_address, ERC20.abi, signer);
      const decimals = await tokenContract.decimals();
      const fee = await tokenExchange.fee(); 
      const bigNum = BigNumber.from(formattedNum.toString()).mul(
        BigNumber.from(10).pow(decimals)
      );

      const GAS = '5';
      let gasPrice = await provider.getGasPrice();
      const convertGas = ethers.utils.parseUnits(GAS, 'gwei');
      gasPrice.add(convertGas);

      const txn = await tokenExchange.swap(_address, bigNum, {
        value: fee,
        gasPrice: gasPrice,
      });

      let txnHash = '';
      if (txn.hasOwnProperty('hash')) {
        txnHash = txn.hash;
      }
      return {
        success: true,
        hash: txnHash,
        explorer: addresses.Block_Explorer,
      };
    } else {
      return { success: false, message: 'Wrong Network!' };
    }
  } catch (e) {
    return { success: false, message: e.message };
  }
};
